import * as i0 from "@angular/core";
export class NumberService {
    constructor() { }
    /**
     * For the given instance of type <T>, return a new instance of type <T> with rounded number fields.
     * @param source The source model.
     * @param precision The number of significant digits.
     */
    roundModel(source, precision) {
        const roundedTarget = Object.assign({}, source);
        // round number fields
        Object.keys(source)
            .filter((field) => typeof (source[field]) === 'number')
            .forEach((field) => {
            roundedTarget[field] = this.roundNumber(source[field], precision);
        });
        // instance of <T> with rounded fields
        return roundedTarget;
    }
    /**
     * Round the the specified source number to specific precision.
     * @param source The number to round.
     * @param precision The number of significant digits.
     */
    roundNumber(source, precision) {
        return Math.round(source * Math.pow(10, precision)) / Math.pow(10, precision);
    }
}
NumberService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NumberService_Factory() { return new NumberService(); }, token: NumberService, providedIn: "root" });
